module.exports = __webpack_public_path__ + "img/6097@2x.8d7b6d62.png";